import type { ReactNode } from 'react';
import { Box } from '@glplus/glpweb-dsl';
import MainHeader from './MainHeader';
import SideRail from './SideRail';

/**
 * Vendor Admin chrome — composed entirely from DSL primitives (no MUI / raw
 * HTML layout), the same way the vendor portal is built:
 *   - black `MainHeader` (logo + top-nav + account menu)
 *   - black `SideRail` "More tools" sidebar (sticky under the header)
 *   - light page surface for the routed content
 * Admin is footerless (internal staff only) per `portalChrome.admin`.
 */
export function AppShell({ children }: { children: ReactNode }) {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#f5f5f5' }}>
      <MainHeader />
      <Box sx={{ display: 'flex', flex: 1, minHeight: 0 }}>
        <SideRail />
        <Box
          component="main"
          sx={{ flex: 1, minWidth: 0, px: { xs: 2, md: 4 }, py: 4 }}
        >
          <Box sx={{ maxWidth: 1100, mx: 'auto' }}>{children}</Box>
        </Box>
      </Box>
    </Box>
  );
}
